import React, { useState, useEffect, useRef, useCallback } from 'react';
import io from 'socket.io-client';
import { getVoteState } from '../services/api';
import TelaoView from '../components/TelaoView';

/*
 * Página pública do telão em tela cheia: /telao?code=XXXX
 * Mostra o mesmo componente TelaoView usado na prévia do painel.
 * Exibe o resultado por alguns segundos quando uma rodada é encerrada.
 */
const Telao = () => {
  const params = new URLSearchParams(window.location.search);
  const code = (params.get('code') || '').toUpperCase();

  const [state, setState] = useState(null);
  const [lastResult, setLastResult] = useState(null);
  const socketRef = useRef(null);
  const pollRef = useRef(null);
  const resultTimerRef = useRef(null);

  const qrUrl = `${window.location.origin}/votar?code=${code}`;

  const fetchState = useCallback(async () => {
    try {
      const { data } = await getVoteState(code);
      setState(data);
      // se voltou a ter votação em andamento, some com o resultado
      if (data.voting) setLastResult(null);
      return data;
    } catch (e) {
      return null;
    }
  }, [code]);

  useEffect(() => {
    if (!code) return;
    let active = true;

    (async () => {
      const data = await fetchState();
      if (!active || !data) return;

      const serverUrl = process.env.REACT_APP_API_URL || window.location.origin;
      socketRef.current = io(serverUrl, { transports: ['websocket', 'polling'], reconnection: true });
      socketRef.current.on('connect', () => {
        if (data.electionId) socketRef.current.emit('election:join', data.electionId);
      });
      socketRef.current.on('election:state', (s) => {
        setState(s);
        if (s.voting) setLastResult(null);
      });
      socketRef.current.on('vote:count', () => fetchState());
      socketRef.current.on('checkin:count', () => fetchState());
      socketRef.current.on('round:opened', () => { setLastResult(null); fetchState(); });
      socketRef.current.on('round:cancelled', () => { setLastResult(null); fetchState(); });
      socketRef.current.on('round:closed', (r) => {
        // r: { electionMinistryId, round, results, totalVotes, conclusive, winnerName }
        setLastResult({ ...r });
        fetchState();
        if (resultTimerRef.current) clearTimeout(resultTimerRef.current);
        // resultado inconclusivo fica na tela até nova ação; conclusivo idem
      });

      pollRef.current = setInterval(fetchState, 3000);
    })();

    return () => {
      active = false;
      if (socketRef.current) socketRef.current.disconnect();
      if (pollRef.current) clearInterval(pollRef.current);
      if (resultTimerRef.current) clearTimeout(resultTimerRef.current);
    };
  }, [code, fetchState]);

  // lastResult precisa do nome do ministério — anexa a partir do state se faltar
  const resultForView = lastResult
    ? { ...lastResult, name: lastResult.name || (state && state.voting && state.voting.name) || 'Resultado' }
    : null;

  if (!code) {
    return (
      <div className="telao-fullscreen">
        <div className="telao"><div className="telao-center telao-muted"><p>Informe o código: /telao?code=XXXX</p></div></div>
      </div>
    );
  }

  return (
    <div className="telao-fullscreen">
      <TelaoView state={state} lastResult={resultForView} qrUrl={qrUrl} />
    </div>
  );
};

export default Telao;
